import { render, staticRenderFns } from "./kpi-a.vue?vue&type=template&id=5c79f7be&scoped=true"
import script from "./kpi-a.vue?vue&type=script&lang=ts"
export * from "./kpi-a.vue?vue&type=script&lang=ts"
import style0 from "./kpi-a.vue?vue&type=style&index=0&id=5c79f7be&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c79f7be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c79f7be')) {
      api.createRecord('5c79f7be', component.options)
    } else {
      api.reload('5c79f7be', component.options)
    }
    module.hot.accept("./kpi-a.vue?vue&type=template&id=5c79f7be&scoped=true", function () {
      api.rerender('5c79f7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-a/kpi-a.vue"
export default component.exports